import { NavigationLink } from "components/base/base";
import Page from "components/base/Page";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import BizBeautyshots from "./biz";
import WisBeautyshots from "./wis";

const BeautyshotsRoutes = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="biz" element={<BizBeautyshots />} />
        <Route path="wis" element={<WisBeautyshots />} />
        <Route path="*" element={<Navigate to="biz" />} />
      </Route>
    </Routes>
  );
};

const Layout = () => (
  <Page
    leftButtons={
      <div className="flex space-x-4">
        <NavigationLink to="/materials/beautyshots/biz" title="BIZ" />
        <NavigationLink to="/materials/beautyshots/wis" title="WIS" />
      </div>
    }
  >
    <Outlet />
  </Page>
);

export default BeautyshotsRoutes;
